module.exports = __webpack_public_path__ + "photo.png?78d544e660d0ccfd7285ddb481ec5ff6";


//////////////////
// WEBPACK FOOTER
// ./src/img/technique_service/photo.png
// module id = 143
// module chunks = 0